const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class ConditionalDetails extends HTMLElement {
  constructor() {
    super();
    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.content = this.querySelector("[data-content]");

    this.summary.addEventListener("click", (e) => {
      e.preventDefault();

      if (this._allowToggle) {
        this.details.open ? this.close() : this.open();
      }
    });

    const toggleOpen = () => {
      if (!this._allowToggle) {
        this._forceOpen();
      }
    };

    toggleOpen();

    this.onResize = debounce(toggleOpen, 200);
    window.addEventListener("resize", this.onResize);

    this.handleCloseAllEvent = () => {
      if (this._allowToggle) {
        this._forceClose();
      }
    };

    if (!this.ignoreMegaMenuClose) {
      document.addEventListener(
        "mega-menu:close-all",
        this.handleCloseAllEvent,
      );
    }
    this.addEventListener("conditional-details:close", () => this.close());
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
    document.removeEventListener(
      "mega-menu:close-all",
      this.handleCloseAllEvent,
    );
  }

  _forceOpen() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.details.open = true;
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  _forceClose() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.details.open = false;
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  open() {
    if (this.details.open) return;
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.details.open = true;
    if (this.content) {
      this.content.style.height = 0;
      this.content.style.opacity = 0;

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
      });
    }
  }

  close() {
    if (!this.details.open) return;
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.details.open = false;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.content.style.height = 0;
      this.content.style.opacity = 0;
    } else {
      this.details.open = false;
    }
  }

  get _allowToggle() {
    return window.matchMedia(this._mediaQuery).matches;
  }

  get _mediaQuery() {
    return this.getAttribute("allow-toggle-when") || "all";
  }

  get ignoreMegaMenuClose() {
    return this.hasAttribute("ignore-mega-menu-close");
  }
}

if (!customElements.get("conditional-details")) {
  customElements.define("conditional-details", ConditionalDetails);
}
